// @flow

export const ARTICLE_NB_BILLBOARD = 5;
export const ARTICLE_PER_PAGE = 10;
export const ARTICLE_NB_NEWSLETTER = 4;
